import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Radio, Coins, Crown, Search } from "lucide-react";
import { api } from "@/lib/api";
import { useWalkie, Avatar } from "./WalkieLayout";
import { ChannelRow } from "./WalkieChannels";

export default function WalkieHome() {
  const { me } = useWalkie();
  const [mine, setMine] = useState([]);
  const [pub, setPub] = useState([]);
  const [people, setPeople] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => {
    api.get("/walkie/channels", { params: { scope: "mine" } }).then((r) => setMine(r.data.channels.slice(0, 4))).catch(() => {});
    api.get("/walkie/channels").then((r) => setPub(r.data.channels.slice(0, 6))).catch(() => {});
  }, []);
  useEffect(() => {
    const t = setTimeout(() => api.get("/walkie/users", { params: { q } }).then((r) => setPeople(r.data.users.slice(0, 12))).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q]);
  const p = me.profile;
  return (
    <div className="space-y-6" data-testid="walkie-home">
      <div className="rounded-3xl p-5 bg-gradient-to-br from-[#FF6A00]/25 via-[#FF2BD6]/20 to-[#00F0FF]/15 border border-[#FF2BD6]/30 flex items-center gap-4">
        <Avatar p={{ ...p, online: true }} size={56} />
        <div className="flex-1 min-w-0">
          <div className="text-xs wt-muted">Welcome back</div>
          <div className="font-black text-xl truncate">{p.display_name}{p.premium && <Crown className="inline w-4 h-4 ml-1 text-[#FFE300]" />}</div>
          <div className="text-xs flex items-center gap-1 mt-0.5"><Coins className="w-3.5 h-3.5 text-[#FFE300]" /><span data-testid="walkie-home-coins">{me.coins}</span> coins</div>
        </div>
        <Link to="/walkie/store" data-testid="walkie-home-store" className="text-xs font-black bg-[#FFE300] text-black px-3 py-2 rounded-full">Store</Link>
      </div>

      {mine.length > 0 && (
        <section className="space-y-2">
          <h2 className="font-black">Your channels</h2>
          {mine.map((c) => <ChannelRow key={c.id} c={c} />)}
        </section>
      )}
      <section className="space-y-2">
        <div className="flex items-center justify-between"><h2 className="font-black flex items-center gap-2"><Radio className="w-4 h-4 text-[#FF2BD6]" /> Live & popular</h2><Link to="/walkie/channels" className="text-xs text-[#00F0FF] font-bold">All channels</Link></div>
        {pub.map((c) => <ChannelRow key={c.id} c={c} />)}
      </section>
      <section className="space-y-2">
        <h2 className="font-black">Find members</h2>
        <div className="relative"><Search className="w-4 h-4 absolute left-3 top-2.5 wt-muted" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name or @username" data-testid="walkie-people-search" className="wt-input w-full rounded-full pl-9 pr-3 py-2 text-sm outline-none" /></div>
        <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
          {people.map((u) => (
            <Link key={u.user_id} to={`/walkie/u/${u.user_id}`} data-testid={`walkie-person-${u.user_id}`} className="wt-card rounded-2xl p-3 text-center">
              <div className="flex justify-center"><Avatar p={u} size={44} /></div>
              <div className="text-xs font-bold truncate mt-1">{u.display_name}</div>
              <div className="text-[10px] wt-muted truncate">@{u.username}</div>
            </Link>
          ))}
          {people.length === 0 && <div className="text-xs wt-muted col-span-3">No members found.</div>}
        </div>
      </section>
    </div>
  );
}
